import React from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import { useState } from "react";
import TextInput from "../../dumb/TextInput";
import { addTerm } from "../../../redux/ducks/glossary";

const AddTerm = props => {
    const [show, hide, renderModal] = useModal();
    const [dispatch_addTerm, status_addTerm, error_addTerm, event_addTerm] = useStatusThunk(addTerm);

    const [source, setSource] = useState();
    const [target, setTarget] = useState();

    event_addTerm.onSuccess = () => {
        hide();
        setSource(null);
        setTarget(null);
    }

    return (
        <React.Fragment>
            <button className={"button button--primary " + props.className} onClick={show}>Add Term</button>

            {renderModal(
                <React.Fragment>
                    <div className="group">
                        <div className="label">Source</div>
                        <TextInput v={source} set={setSource} />
                    </div>

                    <div className="group">
                        <div className="label">Target</div>
                        <TextInput v={target} set={setTarget} />
                    </div>

                    <div className="group">
                        <DisplayError error={error_addTerm} />
                    </div>

                    <LoadingButton loading={status_addTerm == "pending"} className="button--primary" onClick={() => { dispatch_addTerm({ glossaryID: props.glossaryID, source, target, taskID: props.taskID }) }}>Add Term</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default AddTerm;